import { render, staticRenderFns } from "./ICMSlider.vue?vue&type=template&id=620f1c2f&scoped=true&"
import script from "./ICMSlider.vue?vue&type=script&lang=ts&"
export * from "./ICMSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ICMSlider.vue?vue&type=style&index=0&id=620f1c2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f1c2f",
  null
  
)

export default component.exports